const PAYMENT_STATUS = {
  SUCCESS: 'payment_success',
  INITIATED: 'payment_initiated',
  FAILED: 'payment_failed',
}

export default PAYMENT_STATUS;
